import { formatTimestamp, sortArray } from '@nu-art/ts-common';
import { ModuleFE_RuntimePertinentData } from '../../modules/runtime/index.js';
import { AdvisorConfigKeyFE_PertinentCategory_Order } from '@app/advisor-frontend';
export class PertinentData {
    static modulesToAwait = [ModuleFE_RuntimePertinentData];
    item;
    //######################### Life Cycle #########################
    static createNew = (id) => {
        const item = ModuleFE_RuntimePertinentData.cache.unique(id);
        if (!item)
            return;
        return new PertinentData(item);
    };
    constructor(item) {
        this.item = item;
    }
    static getAllRenderable = () => {
        return ModuleFE_RuntimePertinentData.cache
            .filter(item => !!item.entries.length)
            .map(item => new PertinentData(item));
    };
    static sort = (items) => {
        const config = AdvisorConfigKeyFE_PertinentCategory_Order.get();
        if (!config)
            return items;
        const rank = (id) => { const i = config.indexOf(id); return i === -1 ? Infinity : i; };
        return sortArray(items, item => rank(item.item.categoryId));
    };
    //######################### Public Interface #########################
    getLabel = () => {
        return this.item.label;
    };
    getContent = () => {
        return this.item.entries.map(entry => {
            return {
                key: entry._id,
                text: entry.text,
                timestamp: entry.eventTimestamp ? formatTimestamp('MM/YY', entry.eventTimestamp) : undefined
            };
        });
    };
}
//# sourceMappingURL=PertinentData.js.map